import { Component, Inject, NgZone } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { format } from 'date-fns';
import {
  RequiredEmploymentFields,
  RequiredJobFields,
} from 'server/shared/models/customer';
import { PoolerUser } from 'server/shared/models/user';
import { dbDayDateToken } from 'server/static/dbDayDateToken';

export interface RequiredFieldsDialogData {
  user: PoolerUser;
  requiredFields: RequiredJobFields | RequiredEmploymentFields;
}

export type RequiredFieldsDialogUpdatedFields = {
  dateOfBirth?: string;
};

@Component({
  selector: 'required-fields',
  templateUrl: 'required-fields.component.html',
  styleUrls: ['required-fields.component.scss'],
})
export class RequiredFieldsDialog {
  updatedFields: RequiredFieldsDialogUpdatedFields = {};

  constructor(
    public dialogRef: MatDialogRef<RequiredFieldsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: RequiredFieldsDialogData,
    private ngZone: NgZone,
  ) {
    if (data.requiredFields.dateOfBirth && !data.user.dateOfBirth) {
      this.updatedFields.dateOfBirth = '';
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  selectDateOfBirth(event: MatDatepickerInputEvent<any & string>) {
    this.updatedFields.dateOfBirth = format(event.value, dbDayDateToken);
  }
}
